import { selectGtoState } from "../../../../stateManagement/redux"
import ButtonCircle from "../../../../shared/components/button_circle"
import ButtonBig from "../../../../shared/components/button_big"
import { useSelector } from 'react-redux';
import DatePicker from 'react-datepicker';
import { projectList } from "../../../../shared/util/projectList";
import { useState } from "react";

export const GeneralTab = ({ activeField, setActiveField, cuadrillas, onClickViewActivities, onChangeActivitiesField, executedDate, setExecutedDate, numeroCuadrilla, setNumeroCuadrilla, groupAssigned }: { activeField: any, setActiveField: any, cuadrillas: any[], onClickViewActivities: any, onChangeActivitiesField: any, executedDate: any, setExecutedDate: any, numeroCuadrilla:any, setNumeroCuadrilla:any,groupAssigned:any }) => {

    const mainState = useSelector(selectGtoState);

    const [showModifyNameModal, setShowModifyNameModal] = useState(false)

    const [activeItem, setActiveItem] = useState<any>(null)

    const [newValue, setNewValue] = useState("")


    const onClickModify = (c: any) => {
        setNewValue(c.member)
        setShowModifyNameModal(true)
        setActiveItem(c)
    }

    const onChageCuadrillaName = () => {
        onChangeActivitiesField('Ingenieros', activeItem?.member, newValue)
        setShowModifyNameModal(false)
    }

    const onSetNumeroCuadrilla = (c: any) => {
        if (c>10 || c<1) {
            alert('El numero de cuadrilla debe estar entre 1 y 12, el codigo de cuadrilla se arma automaticamente en el "Grupo" con el numero de cuadrilla, la actividad seleccionada y el campo')
            return;
        }else{
            setNumeroCuadrilla(c)
        }
    }

    return (
        <>
            {/* Modal */}
            {showModifyNameModal &&
                <div className='consolidate_files_container_modal_edit_container'>
                    <div className="consolidate_files_container_modal_edit_container_input_container" >
                        <div className="consolidate_files_container_header">
                            <div>Modificar Nombre de las cuadrillas</div>
                            <ButtonCircle icon="/assets/icons/close.svg" iconHeight={15} iconWidth={15} onClick={() => setShowModifyNameModal(false)} />
                        </div>
                        <div className="consolidate_files_container_body">
                            <div className="consolidate_files_container_custom_input">
                                <label htmlFor="file">Valor Actual : </label>
                                <div className="consolidate_files_container_custom_input_value">{activeItem?.member}</div>
                            </div>
                            <div className="consolidate_files_container_custom_input">
                                <label htmlFor="file">Nuevo Valor </label>
                                <input type="text" value={newValue} onChange={(e) => setNewValue(e.target.value)} className="consolidate_files_container_input" />
                            </div>
                            <ButtonBig text='Guardar Cambios' onClick={() => onChageCuadrillaName()} />
                        </div>
                    </div>
                </div>}
            {/* Custom Inputs */}
            <div className='consolidate_files_container_custom_input_container'>
                <div className="consolidate_files_container_custom_input">
                    <label htmlFor="file">Campo : </label>
                    <select id="activity" name="activity" className='Upload_files_container_form_section_select' value={activeField} onChange={(e) => setActiveField(e.target.value)}>
                        <option value=''>Selecciona una opcion</option>
                        {projectList.map((f, index) => <option key={index} value={f.id}>{f.name}</option>)}
                    </select>
                </div>
                <div className="consolidate_files_container_custom_input">
                    <label htmlFor="file">Cantidad Actividades : </label>
                    <div className="consolidate_files_container_custom_input_value">{mainState?.activitiesWithCarts?.length || 0}</div>
                </div>
                <div className="consolidate_files_container_custom_input">
                    <label htmlFor="file">Cantidad Cartas : </label>
                    <div className="consolidate_files_container_custom_input_value">{mainState?.cardsWithActivities?.length || 0}</div>
                </div>
                <div className="consolidate_files_container_custom_input">
                    <label htmlFor="file">Cantidad Cartas Sin Actividad : </label>
                    <div className="consolidate_files_container_custom_input_value">{mainState?.cardsWithActivities?.filter(x => !x.haveActivity)?.length || 0}</div>
                </div>
                <div className="consolidate_files_container_custom_input">
                    <label htmlFor="file">Tarea Activa : </label>
                    <div className="consolidate_files_container_custom_input_value">{mainState?.activitiesWithCarts?.[0]?.taskId}</div>
                </div>
                <div className="consolidate_files_container_custom_input">
                    <label htmlFor="file">Fecha Ejecutadas actividad: </label>
                    <DatePicker
                        selected={executedDate}
                        onChange={(date) => setExecutedDate(date)}
                        showTimeSelect={false}
                        dateFormat="yyyy-MM-dd"
                        className="consolidate_files_container_custom_input"
                        popperClassName="consolidate_files_container_custom_input_date_picker"
                    />
                </div>
                <div className="consolidate_files_container_custom_input">
                    <label htmlFor="file">Numero de Cuadrilla (1 al 12) : </label>
                    <input 
                        type="number" 
                        value={numeroCuadrilla} 
                        onChange={(e) => onSetNumeroCuadrilla(e.target.value)} 
                        className="Upload_files_container_form_section_select" 
                        style={{ width: '50px', textAlign: 'center' }}
                        min="0" 
                        max="10"
                        step="1" 
                    />
                </div>
                <div className="consolidate_files_container_custom_input">
                    <label htmlFor="file">Grupo : </label>
                    <div className="consolidate_files_container_custom_input_value">{groupAssigned}</div>
                </div>

            </div>

            {/* Cuadrillas */}
            <div className="consolidate_files_container_cuadrillas_container">
                <div>Cuadrillas</div>
                <div className='consolidate_files_container_table_container' style={{ height: '35vh' }}>
                    <div className='consolidate_files_container_table_header'>
                        <div>Ingenieros</div>
                        <div>Cantidad de actividades</div>
                        <div>Cantidad de Cartas</div>
                        <div></div>
                        <div />
                    </div>
                    <div className="consolidate_files_container_table_info_container">
                        {cuadrillas.map((c, i) => (
                            <div className='consolidate_files_container_table_row' key={i}>
                                <div>{c.member.split('/').map((m: string, i: string) => {
                                    return (
                                        <span key={i}>
                                            {c.guestMembers.includes(m.trim()) ? <s style={{ color: 'red' }}>{`${m} / `}</s> : `${m} / `}
                                        </span>
                                    )
                                })}</div >
                                <div>{c.activities}</div>
                                <div>{c.carts}</div>
                                <div className="consolidate_files_container_table_row_buttons">
                                    <ButtonBig text='Modificar' onClick={() => onClickModify(c)} />
                                    <ButtonBig text='ver Actividades' onClick={() => onClickViewActivities(c)} />
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </>
    )

}